import { createFileRoute } from '@tanstack/react-router';

import { V3EventComponentsPage } from '@apps/web/routes/_app/admin/v3_event_components';

export const Route = createFileRoute('/_app/admin/v3-event-components')({
    head: () => ({
        meta: [
            {
                title: 'V3 Event Components | Phoebe Admin',
            },
        ],
    }),
    component: V3EventComponentsPage,
});
